import { useEffect, useState } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import SiteNavbar from "./SiteNavbar";
import SiteFooter from "./SiteFooter";

export default function SiteLayout() {
  const [showTop, setShowTop] = useState(false);
  const location = useLocation();
  const isDetail = location.pathname.startsWith("/detail");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteNavbar />
      <main className="flex-1 w-full">
        <Outlet />
      </main>
      <SiteFooter />

      <div className="h-14 md:hidden" />

      {/* mobile bottom action bar */}
      {!isDetail && (
        <div className="fixed bottom-0 left-0 right-0 z-40 flex items-center justify-around border-t border-background-300/70 bg-background-50/95 px-4 py-2 backdrop-blur-md md:hidden">
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] text-foreground-600 cursor-pointer"
          >
            <i className="ri-arrow-up-double-line text-lg" />
            返回顶部
          </button>
          <Link
            to="/search"
            className="flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] text-foreground-600"
          >
            <i className="ri-search-line text-lg" />
            搜索
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="flex flex-col items-center gap-0.5 px-4 py-1 text-[11px] text-foreground-600 cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg" />
            返回上页
          </button>
        </div>
      )}

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 hidden h-11 w-11 items-center justify-center rounded-full bg-primary-700 text-background-50 transition-colors hover:bg-primary-800 md:flex cursor-pointer"
        >
          <i className="ri-arrow-up-line text-xl" />
        </button>
      )}
    </div>
  );
}